import SurveyAPI from '@/apis/business/teacher/survey-api.js'

export default {
  namespaced: true,
  state: {
    survey: null
  },

  getters: {
  },

  mutations: {
    setSurveyData (state, survey) {
      state.survey = survey
    }
  },

  actions: {

    getSurvey (context) {
      return new Promise((resolve, reject) => {
        SurveyAPI.getAsync('show-popup-servey')
          .then((res) => {
            context.commit('setSurveyData', res.Data)
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
     * @author NVHUY1
     * @description Cập nhật số lần hủy khảo sát của người dùng
     */
    updateCancelCount (context, surveyCustomID) {
      return new Promise((resolve, reject) => {
        SurveyAPI.postAsync(`cancel-count/${surveyCustomID}`)
          .then((res) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @author NVHUY1
     * @description Lưu thông tin khảo sát
     */
    saveSurveyResult (context, params) {
      return new Promise((resolve, reject) => {
        SurveyAPI.postAsync('survey-result', params)
          .then((res) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
